<div style="padding-top: 200px; text-align: center;">
  <img src="/assets/img/logo.png" />
  <br><br>
  Preparando datos, espere por favor
</div>
